module.exports = __webpack_public_path__ + "img/slide1_6.42741191.png";